import isEmpty from 'lodash-es/isEmpty'

import { useInlineNotifications } from '../../../hooks'
import { clearEmptyFields } from '../../../utils/formHelpers'
import { parseServerValidation } from '../../../utils/validation'
import { FormikForm } from '../../Formik'
import { createChat } from '../Chat.api'

import { CHAT_FORM_INITIAL_VALUES } from './ChatForm.constants'
import {
  getChatFormCreationPayload,
  getChatFormValidationSchema,
} from './ChatForm.utils'
import { ChatFormFields } from './ChatFormFields'

function ChatForm({
  FormContainer,
  containerProps,
  initialValues = CHAT_FORM_INITIAL_VALUES,
  setModal,
  onCancel,
  onError,
  onSuccess,
  ...restProps
}) {
  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema = getChatFormValidationSchema()

  function handleSubmit(values, { setErrors, setSubmitting }) {
    const payload = getChatFormCreationPayload({
      values,
    })

    createChat(clearEmptyFields(payload))
      .then(({ data }) => {
        onSuccess?.(data)
      })
      .catch(({ response }) => {
        setSubmitting(false)

        if (isEmpty(response?.data)) {
          onError?.()
        } else {
          setErrors(parseServerValidation(response?.data))
        }
      })
  }

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <ChatFormFields
        {...restProps}
        notifications={notifications}
        setModal={setModal}
        onCancel={onCancel}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ChatForm
